import { createSlice } from '@reduxjs/toolkit';

const leaveTypesSlice = createSlice({
  name: 'leaveTypes',
  initialState: {
    data: {},  // Store by country code: { 'IN': [...], 'US': [...] }
    loading: false,
    error: null,
    lastFetched: {},  // Store last fetch time by country code
  },
  reducers: {
    fetchLeaveTypesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLeaveTypesSuccess: (state, action) => {
      const { countryCode, data } = action.payload;
      state.data[countryCode] = data;
      state.loading = false;
      state.error = null;
      state.lastFetched[countryCode] = Date.now();
    },
    fetchLeaveTypesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchLeaveTypesStart, fetchLeaveTypesSuccess, fetchLeaveTypesFailure } = leaveTypesSlice.actions;
export default leaveTypesSlice.reducer;
